/* eslint-disable max-len */
export default {
  'Warson Spartacus S053': {
    'date': '17/04/2020',
    'timestamps': {
      'views': [],
      'straplines': [
        { 'timestamp': 3, 'duration': 3, 'label': 'grass fed' },
        { 'timestamp': 8, 'duration': 3, 'label': 'home bred' },
        { 'timestamp': 13, 'duration': 3, 'label': 'high health and welfare' },
        { 'timestamp': 19, 'duration': 2, 'label': 'sustainable' },
        { 'timestamp': 24, 'duration': 3, 'label': 'traceable' },
        { 'timestamp': 28, 'duration': 3, 'label': 'nutritionally rich' }
      ]
    },
    'poster': 'https://media.goodbeefindex.org/video/S053/S053_1080.png',
    'thumb': 'https://media.goodbeefindex.org/video/S053/S053_660.png',
    'mp4': 'https://media.goodbeefindex.org/video/S053/mp4/S053.mp4',
    'hls': 'https://media.goodbeefindex.org/video/S053/hls/master.m3u'
  },
  'Warson Elijah S092': {
    'date': '17/04/2020',
    'timestamps': {
      'views': [],
      'straplines': [
        { 'timestamp': 4, 'duration': 3, 'label': 'grass fed' },
        { 'timestamp': 8, 'duration': 3, 'label': 'home bred' },
        { 'timestamp': 15, 'duration': 3, 'label': 'high health and welfare' },
        { 'timestamp': 20, 'duration': 2, 'label': 'sustainable' },
        { 'timestamp': 26, 'duration': 3, 'label': 'traceable' },
        { 'timestamp': 31, 'duration': 3, 'label': 'nutritionally rich' }
      ]
    },
    'poster': 'https://media.goodbeefindex.org/video/S092/S092_1080.png',
    'thumb': 'https://media.goodbeefindex.org/video/S092/S092_660.png',
    'mp4': 'https://media.goodbeefindex.org/video/S092/mp4/S092.mp4',
    'hls': 'https://media.goodbeefindex.org/video/S092/hls/master.m3u'
  },
  'Warson Black Boson U152': {
    'date': '17/04/2020',
    'timestamps': {
      'views': [],
      'straplines': [
        { 'timestamp': 3, 'duration': 3, 'label': 'grass fed' },
        { 'timestamp': 8, 'duration': 3, 'label': 'home bred' },
        { 'timestamp': 13, 'duration': 3, 'label': 'high health and welfare' },
        { 'timestamp': 19, 'duration': 2, 'label': 'sustainable' },
        { 'timestamp': 23, 'duration': 3, 'label': 'traceable' },
        { 'timestamp': 25, 'duration': 3, 'label': 'nutritionally rich' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Black_Boson_U152_June19/img/Warson_Black_Boson_U152_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Black_Boson_U152_June19/img/Warson_Black_Boson_U152_June19_660.jpg',
    'mp4': 'https://media.goodbeefindex.org/video/U152/mp4/U152.mp4',
    'hls': 'https://media.goodbeefindex.org/video/U152/hls/master.m3u'
  },
  // 'Warson Black Boson U152': {
  //   'date': '14/04/2020',
  //   'timestamps': {
  //     'views': [],
  //     'straplines': [
  //       { 'timestamp': 3, 'duration': 3, 'label': 'grass fed' },
  //       { 'timestamp': 8, 'duration': 3, 'label': 'home bred' },
  //       { 'timestamp': 13, 'duration': 3, 'label': 'high health and welfare' },
  //       { 'timestamp': 19, 'duration': 2, 'label': 'sustainable' },
  //       { 'timestamp': 24, 'duration': 3, 'label': 'traceable' },
  //       { 'timestamp': 28, 'duration': 3, 'label': 'nutritionally rich' }
  //     ]
  //   },
  //   'poster': 'https://media.beefbook.com/Warson_Black_Boson_U152_June19/img/Warson_Black_Boson_U152_June19_1080.jpg',
  //   'thumb': 'https://media.beefbook.com/Warson_Black_Boson_U152_June19/img/Warson_Black_Boson_U152_June19_660.jpg',
  //   'mp4': 'https://media.goodbeefindex.org/5d25c6629158327787e0899e/video/U152_Warson_Black_Boson_2/mp4/U152_Warson_Black_Boson_2.mp4',
  //   'hls': 'https://media.goodbeefindex.org/5d25c6629158327787e0899e/video/U152_Warson_Black_Boson_2/hls/master.m3u'
  // },
  // 'Warson Black Boson U152': {
  //   'date': '03/06/2019',
  //   'timestamps': {
  //     'views': [
  //       { 'label': 'Legs & Feet', 'timestamp': 1, 'duration': 2 },
  //       { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
  //       { 'label': 'Forequarter', 'timestamp': 13, 'duration': 2 },
  //       { 'label': 'Rump', 'timestamp': 8.5, 'duration': 2 },
  //       { 'label': 'Locomotion', 'timestamp': 10, 'duration': 3 },
  //       { 'label': 'Scrotum', 'timestamp': 7.5, 'duration': 1 }
  //       // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
  //     ],
  //     'straplines': [
  //       { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
  //     ]
  //   },
  //   'poster': 'https://media.beefbook.com/Warson_Black_Boson_U152_June19/img/Warson_Black_Boson_U152_June19_1080.jpg',
  //   'thumb': 'https://media.beefbook.com/Warson_Black_Boson_U152_June19/img/Warson_Black_Boson_U152_June19_660.jpg',
  //   'mp4': 'https://media.beefbook.com/Warson_Black_Boson_U152_June19/mp4/Warson_Black_Boson_U152_June19.mp4',
  //   'dash': 'https://media.beefbook.com/Warson_Black_Boson_U152_June19/dash/master.mpd',
  //   'hls': 'https://media.beefbook.com/Warson_Black_Boson_U152_June19/hls/master.m3u'
  // },
  'Warson Bedrich U155': {
    'date': '03/06/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Bedrich_U155_June19/img/Warson_Bedrich_U155_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Bedrich_U155_June19/img/Warson_Bedrich_U155_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Bedrich_U155_June19/mp4/Warson_Bedrich_U155_June19.mp4',
    'dash': 'https://media.beefbook.com/Warson_Bedrich_U155_June19/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Bedrich_U155_June19/hls/master.m3u'
  },
  'Warson Black Phineas U148': {
    'date': '03/06/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Black_Phineas_U148_June19/img/Warson_Black_Phineas_U148_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Black_Phineas_U148_June19/img/Warson_Black_Phineas_U148_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Black_Phineas_U148_June19/mp4/Warson_Black_Phineas_U148_June19.mp4',
    'dash': 'https://media.beefbook.com/Warson_Black_Phineas_U148_June19/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Black_Phineas_U148_June19/hls/master.m3u'
  },
  'Warson Eckhart U192': {
    'date': '22/07/2019',
    'timestamps': {
      'views': [
        { 'label': 'Legs & Feet', 'timestamp': 10.5, 'duration': 2 },
        { 'label': 'Loin', 'timestamp': 11.5, 'duration': 1.5 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        { 'label': 'Locomotion', 'timestamp': 2.5, 'duration': 2 },
        { 'label': 'Scrotum', 'timestamp': 14.53, 'duration': 0.5 }
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/img/poster_1080/UK373831500192WarsonEckhart_1080.png',
    'thumb': 'https://media.beefbook.com/img/thumb_660/UK373831500192WarsonEckhart_660.png',
    'mp4': 'https://media.beefbook.com/UK373831500192WarsonEckhart/mp4/UK373831500192WarsonEckhart.mp4',
    'dash': 'https://media.beefbook.com/UK373831500192WarsonEckhart/dash/master.mpd',
    'hls': 'https://media.beefbook.com/UK373831500192WarsonEckhart/hls/master.m3u'
  },
  'Warson Elgar U168': {
    'date': '03/06/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Elgar_U168_June19/img/Warson_Elgar_U168_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Elgar_U168_June19/img/Warson_Elgar_U168_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Elgar_U168_June19/mp4/Warson_Elgar_U168_June19.mp4',
    'dash': 'https://media.beefbook.com/Warson_Elgar_U168_June19/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Elgar_U168_June19/hls/master.m3u'
  },
  'Warson Elon U153': {
    'date': '17/04/2020',
    'timestamps': {
      'views': [],
      'straplines': [
        { 'timestamp': 6, 'duration': 6, 'label': 'grass fed' },
        { 'timestamp': 15, 'duration': 6, 'label': 'home bred' },
        { 'timestamp': 25, 'duration': 6, 'label': 'high health and welfare' },
        { 'timestamp': 35, 'duration': 6, 'label': 'sustainable' },
        { 'timestamp': 45, 'duration': 6, 'label': 'traceable' },
        { 'timestamp': 60, 'duration': 6, 'label': 'nutritionally rich' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Elon_U153_June19/img/Warson_Elon_U153_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Elon_U153_June19/img/Warson_Elon_U153_June19_660.jpg',
    'mp4': 'https://media.goodbeefindex.org/video/U153/mp4/U153.mp4',
    'hls': 'https://media.goodbeefindex.org/video/U153/hls/master.m3u'
  },
  // 'Warson Elon U153': {
  //   'date': '03/06/2019',
  //   'timestamps': {
  //     'views': [
  //       // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
  //       // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
  //       // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
  //       // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
  //       // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
  //       // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
  //       // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
  //     ],
  //     'straplines': [
  //       // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
  //     ]
  //   },
  //   'poster': 'https://media.beefbook.com/Warson_Elon_U153_June19/img/Warson_Elon_U153_June19_1080.jpg',
  //   'thumb': 'https://media.beefbook.com/Warson_Elon_U153_June19/img/Warson_Elon_U153_June19_660.jpg',
  //   'mp4': 'https://media.beefbook.com/Warson_Elon_U153_June19/mp4/Warson_Elon_U153_June19.mp4',
  //   'dash': 'https://media.beefbook.com/Warson_Elon_U153_June19/dash/master.mpd',
  //   'hls': 'https://media.beefbook.com/Warson_Elon_U153_June19/hls/master.m3u'
  // },
  'Warson Boss Lad U166': {
    'date': '03/06/2019',
    'timestamps': {
      'views': [
        { 'label': 'Legs & Feet', 'timestamp': 5, 'duration': 2 },
        { 'label': 'Loin', 'timestamp': 2, 'duration': 2 },
        { 'label': 'Forequarter', 'timestamp': 3.5, 'duration': 2 },
        { 'label': 'Rump', 'timestamp': 14.5, 'duration': 2 },
        { 'label': 'Locomotion', 'timestamp': 12, 'duration': 2 }
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Boss_Lad_U166_June19/img/Warson_Boss_Lad_U166_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Boss_Lad_U166_June19/img/Warson_Boss_Lad_U166_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Boss_Lad_U166_June19/mp4/Warson_Boss_Lad_U166_June19.mp4',
    'dash': 'https://media.beefbook.com/Warson_Boss_Lad_U166_June19/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Boss_Lad_U166_June19/hls/master.m3u'
  },
  'Warson Elliott U149': {
    'date': '03/06/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Elliott_U149_June19/img/Warson_Elliott_U149_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Elliott_U149_June19/img/Warson_Elliott_U149_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Elliott_U149_June19/mp4/Warson_Elliott_U149_June19.mp4',
    'dash': 'https://media.beefbook.com/Warson_Elliott_U149_June19/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Elliott_U149_June19/hls/master.m3u'
  },
  'Warson Equinity U157': {
    'date': '03/06/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Equinity_U157_June19/img/Warson_Equinity_U157_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Equinity_U157_June19/img/Warson_Equinity_U157_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Equinity_U157_June19/mp4/Warson_Equinity_U157_June19.mp4',
    'dash': 'https://media.beefbook.com/Warson_Equinity_U157_June19/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Equinity_U157_June19/hls/master.m3u'
  },
  'Warson Erroll U206': {
    'date': '03/06/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Erroll_U206_June19/img/Warson_Erroll_U206_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Erroll_U206_June19/img/Warson_Erroll_U206_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Erroll_U206_June19/mp4/Warson_Erroll_U206_June19.mp4',
    'dash': 'https://media.beefbook.com/Warson_Erroll_U206_June19/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Erroll_U206_June19/hls/master.m3u'
  },
  'Warson Fine Gent U200': {
    'date': '22/07/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        { 'label': 'Loin', 'timestamp': 1, 'duration': 2 },
        { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        { 'label': 'Rump', 'timestamp': 12.5, 'duration': 1 },
        { 'label': 'Locomotion', 'timestamp': 4.5, 'duration': 2 }
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Fine_Gent_U200_June19/img/Warson_Fine_Gent_U200_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Fine_Gent_U200_June19/img/Warson_Fine_Gent_U200_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/UK373831600200WarsonFineGent/mp4/UK373831600200WarsonFineGent.mp4',
    'dash': 'https://media.beefbook.com/UK373831600200WarsonFineGent/dash/master.mpd',
    'hls': 'https://media.beefbook.com/UK373831600200WarsonFineGent/hls/master.m3u'
  },
  'Warson Jodarmi U167': {
    'date': '22/07/2019',
    'timestamps': {
      'views': [
        { 'label': 'Legs & Feet', 'timestamp': 1.5, 'duration': 2 },
        { 'label': 'Loin', 'timestamp': 14, 'duration': 2 },
        { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        { 'label': 'Locomotion', 'timestamp': 13, 'duration': 2 }
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Jodarmi_U167_June19/img/Warson_Jodarmi_U167_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Jodarmi_U167_June19/img/Warson_Jodarmi_U167_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/UK373831100167WarsonJodarmi/mp4/UK373831100167WarsonJodarmi.mp4',
    'dash': 'https://media.beefbook.com/UK373831100167WarsonJodarmi/dash/master.mpd',
    'hls': 'https://media.beefbook.com/UK373831100167WarsonJodarmi/hls/master.m3u'
  },
  'Warson Kinkaid U187': {
    'date': '03/06/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Kinkaid_U187_June19/img/Warson_Kinkaid_U187_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Kinkaid_U187_June19/img/Warson_Kinkaid_U187_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Kinkaid_U187_June19/mp4/Warson_Kinkaid_U187_June19.mp4',
    'dash': 'https://media.beefbook.com/Warson_Kinkaid_U187_June19/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Kinkaid_U187_June19/hls/master.m3u'
  },
  'Warson Eustace U179': {
    'date': '03/06/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Eustace_U179_June19/img/Warson_Eustace_U179_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Eustace_U179_June19/img/Warson_Eustace_U179_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Eustace_U179_June19/mp4/Warson_Eustace_U179_June19.mp4',
    'dash': 'https://media.beefbook.com/Warson_Eustace_U179_June19/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Eustace_U179_June19/hls/master.m3u'
  },
  'Warson Master Bryant U212 June19_1': {
    'date': '03/06/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Master_Bryant_U212_June19_1/img/Warson_Master_Bryant_U212_June19_1_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Master_Bryant_U212_June19_1/img/Warson_Master_Bryant_U212_June19_1_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Master_Bryant_U212_June19_1/mp4/Warson_Master_Bryant_U212_June19_1.mp4',
    'dash': 'https://media.beefbook.com/Warson_Master_Bryant_U212_June19_1/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Master_Bryant_U212_June19_1/hls/master.m3u'
  },
  'Warson Master Bryant U212': {
    'date': '03/06/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Master_Bryant_U212_June19/img/Warson_Master_Bryant_U212_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Master_Bryant_U212_June19/img/Warson_Master_Bryant_U212_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Master_Bryant_U212_June19/mp4/Warson_Master_Bryant_U212_June19.mp4',
    'dash': 'https://media.beefbook.com/Warson_Master_Bryant_U212_June19/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Master_Bryant_U212_June19/hls/master.m3u'
  },
  'Warson Prometheus U189': {
    'date': '22/07/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Prometheus_U189_June19/img/Warson_Prometheus_U189_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Prometheus_U189_June19/img/Warson_Prometheus_U189_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/UK373831200189WarsonPrometheus/mp4/UK373831200189WarsonPrometheus.mp4',
    'dash': 'https://media.beefbook.com/UK373831200189WarsonPrometheus/dash/master.mpd',
    'hls': 'https://media.beefbook.com/UK373831200189WarsonPrometheus/hls/master.m3u'
  },
  'Warson Roscoe U176': {
    'date': '22/07/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/img/poster_1080/UK373831300176WarsonRoscoe_1080.png',
    'thumb': 'https://media.beefbook.com/img/thumb_660/UK373831300176WarsonRoscoe_660.png',
    'mp4': 'https://media.beefbook.com/UK373831300176WarsonRoscoe/mp4/UK373831300176WarsonRoscoe.mp4',
    'dash': 'https://media.beefbook.com/UK373831300176WarsonRoscoe/dash/master.mpd',
    'hls': 'https://media.beefbook.com/UK373831300176WarsonRoscoe/hls/master.m3u'
  },
  'Warson Roscoe U180': {
    'date': '03/06/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        { 'label': 'Loin', 'timestamp': 6, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        { 'label': 'Rump', 'timestamp': 1, 'duration': 2 },
        { 'label': 'Locomotion', 'timestamp': 10, 'duration': 2 },
        { 'label': 'Scrotum', 'timestamp': 14.4, 'duration': 1 }
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Roscoe_U180_June19/img/Warson_Roscoe_U180_June19_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Roscoe_U180_June19/img/Warson_Roscoe_U180_June19_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Roscoe_U180_June19/mp4/Warson_Roscoe_U180_June19.mp4',
    'dash': 'https://media.beefbook.com/Warson_Roscoe_U180_June19/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Roscoe_U180_June19/hls/master.m3u'
  },
  'BeefBook Drone Clip': {
    'date': '06/05/2019',
    'timestamps': {
      'views': []
    },
    'poster': 'https://media.beefbook.com/BeefBook_Drone_Clip/img/drone_poster_1080.jpg',
    'thumb': 'https://media.beefbook.com/BeefBook_Drone_Clip/img/Drone_Thumb_660.jpg',
    'mp4': 'https://media.beefbook.com/BeefBook_Drone_Clip/mp4/BeefBook_Drone_Clip.mp4',
    'dash': 'https://media.beefbook.com/BeefBook_Drone_Clip/dash/master.mpd',
    'hls': 'https://media.beefbook.com/BeefBook_Drone_Clip/hls/master.m3u8'
  },
  'Warson Video': {
    // 'date': '20/03/2020',
    'timestamps': {
      'views': [],
      'straplines': [
        { 'timestamp': 2, 'duration': 3, 'label': 'grass fed' },
        { 'timestamp': 6, 'duration': 3, 'label': 'home bred' },
        { 'timestamp': 10, 'duration': 3, 'label': 'high health and welfare' },
        { 'timestamp': 14, 'duration': 2, 'label': 'sustainable' },
        { 'timestamp': 17, 'duration': 3, 'label': 'nutritionally rich' }
      ]
    },
    'poster': 'https://media.goodbeefindex.org/Warson_Beef_GBI_Video_Clip/warson_farm.png',
    'thumb': 'https://media.goodbeefindex.org/Warson_Beef_GBI_Video_Clip/warson_farm_thumb_660.png',
    'mp4': 'https://media.goodbeefindex.org/Warson_Beef_GBI_Video_Clip/mp4/Warson_Beef_GBI_Video_Clip.mp4',
    'dash': 'https://media.goodbeefindex.org/Warson_Beef_GBI_Video_Clip/dash/master.mpd',
    'hls': 'https://media.goodbeefindex.org/Warson_Beef_GBI_Video_Clip/hls/master.m3u8'
  },
  'Warson Everly U162': {
    'date': '22/07/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/img/poster_1080/UK373831300162WarsonEverly_1080.png',
    'thumb': 'https://media.beefbook.com/img/thumb_660/UK373831300162WarsonEverly_660.png',
    'mp4': 'https://media.beefbook.com/UK373831300162WarsonEverly/mp4/UK373831300162WarsonEverly.mp4',
    'dash': 'https://media.beefbook.com/UK373831300162WarsonEverly/dash/master.mpd',
    'hls': 'https://media.beefbook.com/UK373831300162WarsonEverly/hls/master.m3u'
  },
  'Warson Kincaid U187': {
    'date': '29/04/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/img/poster_1920/Warson_Kincaid_U187_30-4-19.jpg',
    'thumb': 'https://media.beefbook.com/img/thumb_330/Warson_Kincaid_U187_30-4-19.jpg',
    'mp4': 'https://media.beefbook.com/web/Warson_Kincaid_U187_1080.mp4',
    'dash': 'https://media.beefbook.com/dash/Warson_Kincaid_U187/master.mpd',
    'hls': 'https://media.beefbook.com/hls/Warson_Kincaid_U187/master.m3u8'
  },
  'Warson Esteemed U166': {
    'date': '29/04/2019',
    'timestamps': {
      'views': [
        { 'label': 'Legs & Feet', 'timestamp': 4, 'duration': 2 },
        { 'label': 'Loin', 'timestamp': 10, 'duration': 1 },
        { 'label': 'Forequarter', 'timestamp': 9, 'duration': 1 },
        { 'label': 'Rump', 'timestamp': 7.5, 'duration': 2 },
        { 'label': 'Locomotion', 'timestamp': 11.5, 'duration': 2 },
        { 'label': 'Scrotum', 'timestamp': 12.8, 'duration': 0.5 }
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/img/poster_1920/Warson_Esteemed_U166_30-4-19.jpg',
    'thumb': 'https://media.beefbook.com/img/thumb_330/Warson_Esteemed_U166_30-4-19.jpg',
    'mp4': 'https://media.beefbook.com/web/Warson_Esteemed_U166_1080.mp4',
    'dash': 'https://media.beefbook.com/dash/Warson_Esteemed_U166/master.mpd',
    'hls': 'https://media.beefbook.com/hls/Warson_Esteemed_U166/master.m3u8'
  },
  'Warson Elias U226': {
    'date': '29/04/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/img/poster_1920/Warson_Elias_U226_30-4-19.jpg',
    'thumb': 'https://media.beefbook.com/img/thumb_330/Warson_Elias_U226_30-4-19.jpg',
    'mp4': 'https://media.beefbook.com/web/Warson_Elias_U226_1080.mp4',
    'dash': 'https://media.beefbook.com/dash/Warson_Elias_U226/master.mpd',
    'hls': 'https://media.beefbook.com/hls/Warson_Elias_U226/master.m3u8'
  },
  'Warson Erroll U204': {
    'date': '22/07/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/img/poster_1080/UK373831300204WarsonErroll_1080.png',
    'thumb': 'https://media.beefbook.com/img/thumb_660/UK373831300204WarsonErroll_660.png',
    'mp4': 'https://media.beefbook.com/UK373831300204WarsonErroll/mp4/UK373831300204WarsonErroll.mp4',
    'dash': 'https://media.beefbook.com/UK373831300204WarsonErroll/dash/master.mpd',
    'hls': 'https://media.beefbook.com/UK373831300204WarsonErroll/hls/master.m3u'
  },
  'Warson Kaliko U169': {
    'date': '29/04/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/img/poster_1920/Warson_Kaliko_U169_30-4-19.jpg',
    'thumb': 'https://media.beefbook.com/img/thumb_330/Warson_Kaliko_U169_30-4-19.jpg',
    'mp4': 'https://media.beefbook.com/web/Warson_Kaliko_U169_1080.mp4',
    'dash': 'https://media.beefbook.com/dash/Warson_Kaliko_U169/master.mpd',
    'hls': 'https://media.beefbook.com/hls/Warson_Kaliko_U169/master.m3u8'
  },
  'Warson Evita T134': {
    'date': '07/05/2019',
    'timestamps': {
      'views': [
        // { 'label': 'Legs & Feet', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Loin', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Forequarter', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Rump', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Locomotion', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Scrotum', 'timestamp': 3, 'duration': 2 },
        // { 'label': 'Udder', 'timestamp': 3, 'duration': 2 }
      ],
      'straplines': [
        // { 'timestamp': 8, 'duration': 12, 'label': 'Good Beef traits are Loin, Leg & Feet, Forequarter, Rump, Locomotion, Scrotum, Udder' }
      ]
    },
    'poster': 'https://media.beefbook.com/Warson_Evita_T134/img/Warson_Evita_T134_1080.jpg',
    'thumb': 'https://media.beefbook.com/Warson_Evita_T134/img/Warson_Evita_T134_660.jpg',
    'mp4': 'https://media.beefbook.com/Warson_Evita_T134/mp4/Warson_Evita_T134.mp4',
    'dash': 'https://media.beefbook.com/Warson_Evita_T134/dash/master.mpd',
    'hls': 'https://media.beefbook.com/Warson_Evita_T134/hls/master.m3u'
  }
};
